const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/about"],
    exact: true,
    component: "About",
  },
  {
    path: ["/career"],
    exact: true,
    component: "Career",
  },
  {
    path: ["/contact"],
    exact: true,
    component: "Contact",
  },
  {
    path: ["/price"],
    exact: true,
    component: "Price",
  },
  {
    path: ["/blog"],
    exact: true,
    component: "Blog",
  },
];

export default routes;
